module.exports = __webpack_public_path__ + "img/logo.beb616f0.png";